import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  GIFT_VOUCHER_LIST, GIFT_VOUCHER_DATA, GIFT_VOUCHER_CREATE,
  GIFT_VOUCHER_UPDATE, GIFT_VOUCHER_DELETE, GIFT_VOUCHER_SEARCH,
  GIFT_VOUCHER_REDEEM, GIFT_VOUCHER_VOID, GIFT_VOUCHER_RESEND_EMAIL,
} from "./actionType";
import {
  giftVoucherListSuccess, giftVoucherListFailure,
  giftVoucherDataSuccess, giftVoucherDataFailure,
  giftVoucherCreateSuccess, giftVoucherCreateFailure,
  giftVoucherUpdateSuccess, giftVoucherUpdateFailure,
  giftVoucherDeleteSuccess, giftVoucherDeleteFailure,
  giftVoucherSearchSuccess, giftVoucherSearchFailure,
  giftVoucherRedeemSuccess, giftVoucherRedeemFailure,
  giftVoucherVoidSuccess, giftVoucherVoidFailure,
  giftVoucherResendEmailSuccess, giftVoucherResendEmailFailure,
} from "./action";
import {
  giftVoucherListApi, giftVoucherDataApi, giftVoucherCreateApi,
  giftVoucherUpdateApi, giftVoucherDeleteApi, giftVoucherSearchApi,
  giftVoucherRedeemApi, giftVoucherVoidApi, giftVoucherResendEmailApi,
} from "../../helpers/fakebackend_helper";

function* handleList()              { try { yield put(giftVoucherListSuccess(yield call(giftVoucherListApi)));              } catch (e) { yield put(giftVoucherListFailure(e));   } }
function* handleData({ payload })   { try { yield put(giftVoucherDataSuccess(yield call(giftVoucherDataApi, payload)));     } catch (e) { yield put(giftVoucherDataFailure(e));   } }
function* handleCreate({ payload }) { try { yield put(giftVoucherCreateSuccess(yield call(giftVoucherCreateApi, payload))); } catch (e) { yield put(giftVoucherCreateFailure(e)); } }
function* handleUpdate({ payload }) { try { yield put(giftVoucherUpdateSuccess(yield call(giftVoucherUpdateApi, payload))); } catch (e) { yield put(giftVoucherUpdateFailure(e)); } }
function* handleDelete({ payload }) { try { yield put(giftVoucherDeleteSuccess(yield call(giftVoucherDeleteApi, payload))); } catch (e) { yield put(giftVoucherDeleteFailure(e)); } }
function* handleSearch({ payload }) { try { yield put(giftVoucherSearchSuccess(yield call(giftVoucherSearchApi, payload))); } catch (e) { yield put(giftVoucherSearchFailure(e)); } }
function* handleRedeem({ payload }) { try { yield put(giftVoucherRedeemSuccess(yield call(giftVoucherRedeemApi, payload))); } catch (e) { yield put(giftVoucherRedeemFailure(e)); } }
function* handleVoid({ payload })   { try { yield put(giftVoucherVoidSuccess(yield call(giftVoucherVoidApi, payload)));     } catch (e) { yield put(giftVoucherVoidFailure(e));   } }
function* handleResend({ payload }) { try { yield put(giftVoucherResendEmailSuccess(yield call(giftVoucherResendEmailApi, payload))); } catch (e) { yield put(giftVoucherResendEmailFailure(e)); } }

export default function* GiftVoucherSaga() {
  yield all([
    fork(function* () { yield takeEvery(GIFT_VOUCHER_LIST,         handleList);   }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_DATA,         handleData);   }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_CREATE,       handleCreate); }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_UPDATE,       handleUpdate); }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_DELETE,       handleDelete); }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_SEARCH,       handleSearch); }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_REDEEM,       handleRedeem); }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_VOID,         handleVoid);   }),
    fork(function* () { yield takeEvery(GIFT_VOUCHER_RESEND_EMAIL, handleResend); }),
  ]);
}
